module.exports = __webpack_public_path__ + "static/media/Couple.4928996f.jpg";